import LmsOverview from "@/routes/lms/lmsOverview";
import LmsCourses from "@/routes/lms/lmsCourses";
import LmsLearnerCourses from "@/routes/lms/lmsLearnerCourses";
import LmsAdminCoursesView from "@/routes/lms/lmsAdminCoursesView";
import LmsCourseOverview from "@/routes/lms/lmsCourseOverview";
import LmsCreateCourse from "@/routes/lms/lmsCreateCourse";
import LmsCourseOverviewReadOnly from "@/routes/lms/lmsCourseOverviewReadOnly";
import LmsManagerCourseRoute from "@/routes/lms/lmsManagerCourseRoute";
import LmsScormPlayer from "@/routes/lms/lmsScormPlayer";
import LmsEnrolments from "@/routes/lms/lmsEnrolments";
import LmsEnrolmentAssignments from "@/routes/lms/lmsEnrolmentAssignments";
import LmsBilling from "@/routes/lms/lmsBilling";
import {
  COURSE_ADMIN_PERMISSION,
  LMS_BILLING_PERMISSION,
} from "@/components/lms/lms.utils";

const adminLmsSubRoutes = [
  {
    path: "/kaerdemy/administrator/billing",
    name: "lms_overview",
    icon: "billing",
    index: 6003,
    permission: LMS_BILLING_PERMISSION,
  },
  {
    path: "/kaerdemy/administrator/overview",
    name: "lms_company_details",
    icon: "lmsOverview",
    iconCustomConfigs: {
      strokeWidth: "1.75",
    },
    index: 6000,
    permission: COURSE_ADMIN_PERMISSION,
  },
  {
    path: "/kaerdemy/courses",
    name: "course_library",
    icon: "courses",
    index: 6001,
    permission: COURSE_ADMIN_PERMISSION,
  },
  {
    path: "/kaerdemy/administrator/enrolments",
    name: "course_progress",
    icon: "enrolments",
    index: 6002,
    permission: COURSE_ADMIN_PERMISSION,
  },
  {
    path: "/kaerdemy/administrator/enrolmentAssignments",
    name: "enrolment_assignments",
    icon: "enrolmentAssignments",
    index: 6004,
    permission: COURSE_ADMIN_PERMISSION,
  },
];

const lmsSubrouteContent = [
  {
    path: "administrator/overview",
    element: <LmsOverview />,
    name: "Administrator Overview",
    icon: "",
  },
  {
    path: "manager/overview",
    element: <LmsOverview />,
    name: "Manager Overview",
    icon: "",
  },
  {
    path: "courses",
    element: <LmsCourses redirectToEffectiveMode />,
    name: "Courses",
    icon: "",
  },
  {
    path: "learner/courses",
    element: <LmsLearnerCourses requiredMode="learner" />,
    name: "Learner Courses",
    icon: "",
  },
  {
    path: "learner/enrolments/:enrolmentId/overview",
    element: (
      <LmsCourseOverviewReadOnly
        requiredMode="learner"
        subdomain="portal"
      />
    ),
    name: "Learner Enrolment Overview",
    icon: "",
  },
  {
    path: "learner/courses/:courseId/overview",
    element: (
      <LmsCourseOverviewReadOnly
        requiredMode="learner"
        subdomain="portal"
      />
    ),
    name: "Learner Course Overview",
    icon: "",
  },
  {
    path: "learner/courses/:courseId/play",
    element: <LmsScormPlayer />,
    name: "Learner Course Player",
    icon: "",
  },
  {
    path: "administrator/courses",
    element: <LmsAdminCoursesView requiredMode="administrator" />,
    name: "Administrator Courses",
    icon: "",
  },
  {
    path: "administrator/courses/create",
    element: <LmsCreateCourse requiredMode="administrator" />,
    name: "Administrator Create Course",
    icon: "",
  },
  {
    path: "administrator/courses/:courseId/overview",
    element: <LmsCourseOverview requiredMode="administrator" />,
    name: "Administrator Course Overview",
    icon: "",
  },
  {
    path: "manager/courses",
    element: <LmsAdminCoursesView requiredMode="manager" />,
    name: "Manager Courses",
    icon: "",
  },
  {
    path: "manager/courses/:courseId/overview",
    element: <LmsManagerCourseRoute />,
    name: "Manager Course Overview",
    icon: "",
  },
  {
    path: "administrator/enrolments",
    element: <LmsEnrolments requiredMode="administrator" />,
    name: "Administrator enrolments",
    icon: "",
  },
  {
    path: "administrator/billing",
    element: <LmsBilling />,
    name: "Administrator billing",
    icon: "",
  },
  {
    path: "manager/enrolments",
    element: <LmsEnrolments requiredMode="manager" />,
    name: "Manager enrolments",
    icon: "",
  },
  {
    path: "administrator/enrolmentAssignments",
    element: <LmsEnrolmentAssignments requiredMode="administrator" />,
    name: "Administrator enrolment assignments",
    icon: "",
  },
  {
    path: "manager/enrolmentAssignments",
    element: <LmsEnrolmentAssignments requiredMode="manager" />,
    name: "Manager enrolment assignments",
    icon: "",
  },
];

export { adminLmsSubRoutes, lmsSubrouteContent };
